export default "__VITE_ASSET__gTSzaP3i__"